module.exports = __webpack_public_path__ + "static/media/studentSLT@2x.3468e1d0.png";